import React from 'react';
import '../StyleSheets/SideBar.css';

import appIcon from '../Graphics/Icons/corona_metrics_app_icon.png';
// import kaymaLogo from '../Graphics/Logos/kayma_logo.svg';
// import meidataLogo from '../Graphics/Logos/meidata_logo.svg';
import mofLogo from '../Graphics/Logos/mof_logo.svg';

export default class SideBar extends React.Component {

    state = {
        isBarOpen: false,
    }

    render() {
        const { lastUpdate, onNav } = this.props;

        let lastUpdateString = "לא ידוע";
        if( lastUpdate !== undefined ) {
            
            const date = new Date( lastUpdate );
            lastUpdateString = date.toLocaleDateString("he-IL");
        }

        return [
        
            <img key="app_icon" src={appIcon} alt="corona_metrics_icon" id="coronaMetricsAppIcon"
                onClick ={()=> {this.setState({isBarOpen: !this.state.isBarOpen}); }}
            />,
            <div key="sidebar_cont" id="sideBarCont" className={this.state.isBarOpen ? "sideBarContOpen" : "sideBarContClose"}>
                <div key="last_update" id="lastUpdateLabel"><p>עדכון אחרון:</p>{lastUpdateString}</div>,
                <ul id="sideBarNav">
                    <li className="sidebarNavItem" onClick={()=>{ onNav(0); this.setState({isBarOpen:false}); }}>גרף מדדי יום</li>
                    <li className="sidebarNavItem" onClick={()=>{ onNav(1); this.setState({isBarOpen:false}); }}>תמונת מצב גלובלית</li>
                    <li className="sidebarNavItem" onClick={()=>{ onNav(2); this.setState({isBarOpen:false}); }}>כרוניקת מדיניות</li>
                    <li className="sidebarNavItem" onClick={()=>{ onNav(3); this.setState({isBarOpen:false}); }}>מידע פיננסי</li>

                </ul>
                <img src={mofLogo} alt="mof_logo" id="mofLogo" 
                    onClick ={()=> { window.open("https://www.gov.il/he/departments/Units/department_budget", "blank"); }}
                /> 
                {/* <img src={kaymaLogo} alt="kayma_logo" id="kaymaLogo" className="orgLogo"
                    onClick ={()=> { window.open("https://kayma.com/", "blank"); }}
                /> 
                <img src={meidataLogo} alt="meidata_logo" id="meidataLogo" className="orgLogo"
                    onClick ={()=> { window.open("https://meidata.com/", "blank"); }} 
                />
                */}
            </div>
        ]
    }
}